module.exports = __webpack_public_path__ + "static/media/clouds-sun.93fb780d.svg";